import { useFormContext } from "react-hook-form";
import type { ReactNode } from "react";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    name?: string;
    label?: string;
    placeholder?: string;
    tabIndex?: number;
    autoFocus?: boolean;
    disabled?: boolean;
    /** Renders on the same row as the label (e.g. top-right with justify-between) */
    labelAction?: ReactNode;
}

const Email: React.FC<Props> = ({
    name = "email",
    tabIndex,
    autoFocus,
    label,
    placeholder = "e.g. name@company.com",
    disabled = false,
    labelAction,
}) => {
    const { control } = useFormContext();
    return (
        <ui.FormField
            control={control}
            name={name}
            data-cy={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    {labelAction ? (
                        <div className="flex flex-row justify-between items-center gap-2">
                            <ui.FormLabel className="mb-0">{label ?? "Email"}</ui.FormLabel>
                            <div className="shrink-0">{labelAction}</div>
                        </div>
                    ) : (
                        <ui.FormLabel>{label ?? "Email"}</ui.FormLabel>
                    )}
                    <ui.FormControl>
                        <ui.Input
                            data-testid="email-input"
                            disabled={disabled}
                            autoFocus={autoFocus}
                            tabIndex={tabIndex}
                            autoComplete="email"
                            type="email"
                            placeholder={placeholder}
                            {...field}
                        />
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default Email;
